<template>
  <div class="template_main">
    <van-nav-bar class="main_nav" left-arrow title="报告查看" @click-left="onClickLeft" />
    <div v-loading="loading" class="template" element-loading-text="数据加载中...">
      <div class="template_box">
        <div v-html="templateDetails.title"></div>
        <div
          class="modules"
          v-for="(module, moduleIndex) in templateDetails.modules"
          :key="moduleIndex"
        >
          <div class="mb10" v-html="module.name"></div>
          <div v-for="(paragraph, paragraphIndex) in module.texts" :key="paragraphIndex">
            <span v-html="paragraph" ref="paragraph"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _templateDetail, _readTemplate } from "../../api/test-center-temp";
import { decryptBy } from '@/assets/js/encryption';
function stopBodyScroll(e) {
  e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
}
export default {
  name: 'template',
  data() {
    return {
      loading: false,
      templateId: '',
      templateDetails: {},
    }
  },
  created() {
    this.templateId = this.$route.query.resultId;
    let info = JSON.parse(decryptBy(localStorage.getItem("parentsInfor")));
    if (this.$route.query.status == 1) return
    _readTemplate({
      reportIdList: [this.templateId],
      readUserId: info.id,
      readUserName: info.parentName,
      userPlatformType: 1
    }).then(res => {

    }).catch(err => {
      throw err
    }).finally(() => {

    })
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getDetail(id) {
      this.loading = true;
      _templateDetail(id).then(res => {
        if (res.code == 200 && res.data) {
          this.templateDetails = res.data;
        }
      }).catch(err => {
        throw err
      }).finally(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getDetail(this.templateId)
    document.body.addEventListener('touchmove', stopBodyScroll, { passive: false });

    document.getElementsByClassName("template_box")[0].addEventListener("touchmove", function (e) {
      e.stopPropagation();
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('touchmove', stopBodyScroll);
  }
}
</script>

<style  lang="scss" scoped>
.template_main {
  height: 100%;
  padding-top: 44px;
  // padding-bottom: 10px;
  .main_nav {
    position: fixed;
    width: 100%;
    top: 0;
  }
}
.template {
  // min-height: 100%;
  height: 100%;
  width: 100%;
  background: url(./../../assets/images/test-center/result-bg.png);
  background-size: cover;
  padding: 15px;
  .template_box {
    height: 93%;
    width: 100%;
    background: #fff;
    border-radius: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 20px;
    // .module_name {
    //   font-weight: 500;
    //   margin-bottom: 10px;
    // }
    .modules {
      margin-bottom: 20px;
      ::v-deep p {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
    }
  }
}
</style>